import qs from 'qs';

const CLEAR = 'dwellings/CLEAR'; // @deprecated

const LOAD = 'dwellings/LOAD';
const LOAD_SUCCESS = 'dwellings/LOAD_SUCCESS';
const LOAD_FAIL = 'dwellings/LOAD_FAIL';

const API_ENDPOINT = '/api/dwellings';

export const initialState = {
  path: null,
  data: [],
  meta: {},
  content: null,
  loading: false,
  firstView: true
};

export default function dwellings(state = initialState, action) {
  const { reload } = action;

  if (action.type === LOAD_SUCCESS) {
    const { content = null, data, meta } = action.payload;
    return {
      ...state,
      data,
      meta,
      content,
      path: action.path,
      loading: false
    };
  }
  if (action.type === LOAD_FAIL) {
    return {
      ...state,
      ...initialState,
      loading: false
    };
  }
  if (action.type === LOAD) {
    return {
      ...state,
      loading: !reload,
      firstView: !__CLIENT__
    };
  }
  // @deprecated
  if (action.type === CLEAR) {
    return {
      ...state,
      ...initialState,
      loading: false
    };
  }
  return state;
}

export function dwellingsIsLoaded(globalState, path) {
  const state = globalState.dwellings;
  return state.path === path && state.data.length;
}

export function getDwellings(path, { reload } = {}) {
  return {
    path,
    reload,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${API_ENDPOINT}${path}`)
  };
}

export function getLatestDwellings({ query, ...opts }) {
  return getDwellings(`/latest${query ? `?${qs.stringify(query)}` : ''}`, opts);
}

export function search(query, opts) {
  return getDwellings(`/search?${qs.stringify(query)}`, opts);
}

export function getCityDwellings(city, { query, ...opts } = {}) {
  return getDwellings(
    `/area/${city}${query ? `?${qs.stringify(query)}` : ''}`,
    opts
  );
}

// @deprecated, and most likely not used - to be removed
export function clearDwellings() {
  return {
    type: CLEAR
  };
}
